function getColors(theme) {
  let result = {
    SOLVED: '#419641',
    WRONG: '#d9534f',
    CHECKING: '#ecb436',
    UNKNOWN: '#000000',
  }
  if (theme === 'dark') {
    result.UNKNOWN = '#ffffe0';
  }
  return result;
}

const PLANET_MAP = {
  MOON: {
    url: 'https://s3.amazonaws.com/opmbuilder/301_moon/tiles/w/hillshaded-albedo/{z}/{x}/{y}.png',
    minZoom: 3,
    maxZoom: 6,
    tms: true,
    radius: 190000,
  },
  MARS: {
    url: 'http://s3-eu-west-1.amazonaws.com/whereonmars.cartodb.net/viking_mdim21_global/{z}/{x}/{y}.png',
    minZoom: 3,
    maxZoom: 6,
    tms: true,
    radius: 190000,
  },
  EARTH: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    minZoom: 3,
    maxZoom: 12,
    tms: false,
    radius: 90000
  }
}

export { getColors, PLANET_MAP };
